import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

interface Mkt1CardProps {
  title?: string;
  buttonLabel?: string;
}

export default function Mkt1Card({
  title = "Conheça as histórias de quem já transportou com a Nacional GO",
  buttonLabel = "Ver histórias",
}: Mkt1CardProps) {
  return (
    <div className="bg-white rounded-[20px] py-5 px-6 flex items-center justify-between gap-4">
      <span className="text-lg font-semibold text-n-green">{title}</span>
      <Link to="/blog">
        <Button variant="green" type="button" size="sm">
          {buttonLabel}
        </Button>
      </Link>
    </div>
  );
}
